export const TRAINING_ENABLED = import.meta.env.VITE_FEATURE_TRAINING === 'true';
